import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import fb from "../assets/images/sociaux/fb.png";
import sociaux from "../assets/images/sociaux/sociaux.png";
import instagram from "../assets/images/sociaux/instagram.png";
import linkin from "../assets/images/sociaux/linkind.png";
import { getCategories } from "../apiConfig/services";
import FooterShimmer from "./loading/FooterShimmer";

function Footer() {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        setCategories(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Erreur lors de la récupération des catégories", error);
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (isLoading) {
    return <FooterShimmer />;
  }

  const socialLinks = [
    {
      icon: fb,
      name: "Facebook",
      url: "https://www.facebook.com/profile.php?id=61554321442152",
    },
    {
      icon: sociaux,
      name: "Social",
      url: "https://www.facebook.com/profile.php?id=61554321442152",
    },
    {
      icon: linkin,
      name: "LinkedIn",
      url: "https://www.facebook.com/profile.php?id=61554321442152",
    },
    {
      icon: instagram,
      name: "Instagram",
      url: "https://www.facebook.com/profile.php?id=61554321442152",
    },
  ];

  const navigationLinks = [
    { name: "Accueil", path: "/" },
    { name: "A propos", path: "/about" },
    { name: "Parcours proposés", path: "/livres" },
    { name: "Ressources pédagogiques", path: "/ressources" },
  ];

  // Group categories into 4 columns if there are many
  const categoryItems = categories.length > 0 ? categories : [];

  return (
    <footer className="bg-white pt-14 pb-8">
      <div className="container mx-auto px-4 lg:px-[5%]">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-12 gap-x-6 gap-y-10">
          {/* Brand Section - 3 columns on large screens */}
          <div className="lg:col-span-3">
            <div className="mb-6">
              <h1 className="text-3xl font-bold">
                <span className="text-red-600">Tis</span>
                <span className="text-gray-800">radar</span>
              </h1>
              <div className="w-24 h-1 bg-red-600 mt-2"></div>
            </div>

            <div className="space-y-5 text-gray-600">
              <h2 className="font-bold text-xl text-gray-800">Contact</h2>
              <ul className="space-y-4">
                <li className="flex items-center space-x-2">
                  <svg
                    className="w-5 h-5 text-gray-500 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  <a
                    href="tel:+261347168847"
                    className="hover:text-red-600 transition-colors"
                  >
                    +261 34 71 688 47 Faneva
                  </a>
                </li>
                <li className="flex items-start space-x-2">
                  <svg
                    className="w-5 h-5 mt-1 text-gray-500 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <span>BP 1135 Andrainjato 301 Fianarantsoa Madagascar</span>
                </li>
                <li className="flex items-center space-x-2 ">
                  <svg
                    className="w-5 h-5 text-gray-500 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <div className="flex flex-col">
                    <a
                      href="mailto:Fanevaanjaratiana@gmail.com"
                      className="hover:text-red-600 transition-colors"
                    >
                      Fanevaanjaratiana@gmail.com
                    </a>
                    <a
                      href="mailto:rudantupem@gmail.com"
                      className="hover:text-red-600 transition-colors"
                    >
                      rudantupem@gmail.com
                    </a>
                  </div>
                </li>
              </ul>

              <div className="pt-4 flex space-x-5">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transform hover:scale-110 transition-transform"
                  >
                    <img
                      src={social.icon}
                      alt={social.name}
                      className="w-6 h-6"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Navigation Section - 3 columns on large screens */}
          <div className="lg:col-span-3">
            <h2 className="text-xl font-bold text-gray-800 mb-6">
              Explorer
              <div className="w-16 h-1 bg-red-600 mt-1"></div>
            </h2>
            <ul className="space-y-3 text-gray-600">
              {navigationLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="hover:text-red-600 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories Section - 6 columns on large screens for better spacing */}
          <div className="lg:col-span-6">
            <h2 className="text-xl font-bold text-gray-800 mb-6">
              Catégories
              <div className="w-16 h-1 bg-red-600 mt-1"></div>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-3">
              {categoryItems.map((category, index) => (
                <div key={category.id_dom || index} className="text-gray-600">
                  <Link
                    to={`/categories/${encodeURIComponent(
                      category.slug_category
                    )}`}
                    className="hover:text-red-600 transition-colors block"
                  >
                    {category.name_category}
                  </Link>
                </div>
              ))}
              {categories.length === 0 && (
                <p className="text-gray-600">Aucune catégorie disponible.</p>
              )}
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-16 pt-6 border-t border-gray-200 text-center">
          <p className="text-gray-600 text-sm">
            © {new Date().getFullYear()} Tisradar. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
